import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DefaultDecoder_getInstancezsiea2kgjp4b as DefaultDecoder_getInstance } from '../../../../../lightning-server-shared/com/lightningkite/serialization/Defaults.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
import {
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  Decoder23nde051s631g as Decoder,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Decoding.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { get_DefaultSerializersModule10h5j26es502p as get_DefaultSerializersModule } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/urls.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getContextual(_this__u8e3s4, contextualSerializer) {
  try {
    contextualSerializer.pz(new (getContextual$1())(_this__u8e3s4));
  } catch ($p) {
    if ($p instanceof DesWrap()) {
      var e = $p;
      var tmp = e.leh_1;
      return isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
    } else {
      throw $p;
    }
  }
  throw IllegalStateException().kd();
}
function enumValues(_this__u8e3s4) {
  var e = new (EnumValueGetter())(0);
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, _this__u8e3s4.az().u11());
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.i2_1;
  var last = this_0.j2_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      e.neh_1 = item;
      var tmp$ret$0 = _this__u8e3s4.pz(e);
      destination.v(tmp$ret$0);
    }
     while (!(item === last));
  return destination;
}
function set(_this__u8e3s4, instance, index, childSerializer, value) {
  var e = MinEncoder().reh();
  _this__u8e3s4.oz(e, instance);
  var e2 = MinEncoder().reh();
  childSerializer.oz(e2, value);
  var tmp = e.oeh_1;
  var eo = (!(tmp == null) ? isInterface(tmp, KtMutableMap()) : false) ? tmp : THROW_CCE();
  // Inline function 'kotlin.collections.set' call
  var value_0 = e2.oeh_1;
  eo.s3(index, value_0);
  var d = new (MinDecoder())(e.oeh_1);
  return _this__u8e3s4.pz(d);
}
function get(_this__u8e3s4, instance, index, childSerializer) {
  var e = MinEncoder().reh();
  _this__u8e3s4.oz(e, instance);
  var tmp = e.oeh_1;
  var encodedValue = ((!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE()).p3(index);
  var d = new (MinDecoder())(encodedValue);
  return childSerializer.pz(d);
}
function serializationCast(_this__u8e3s4, instance, otherSerializer) {
  var e = MinEncoder().reh();
  _this__u8e3s4.oz(e, instance);
  var d = new (MinDecoder())(e.oeh_1);
  return otherSerializer.pz(d);
}
var DesWrapClass;
function DesWrap() {
  if (DesWrapClass === VOID) {
    class $ extends Exception() {
      static seh(deserializer) {
        var $this = this.td();
        captureStack($this, $this.meh_1);
        $this.leh_1 = deserializer;
        return $this;
      }
    }
    initMetadataForClass($, 'DesWrap');
    DesWrapClass = $;
  }
  return DesWrapClass;
}
var EnumValueGetterClass;
function EnumValueGetter() {
  if (EnumValueGetterClass === VOID) {
    class $ {
      constructor(index) {
        index = index === VOID ? 0 : index;
        this.neh_1 = index;
      }
      mz() {
        return DefaultDecoder_getInstance().a4r_1;
      }
      l13(descriptor) {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      z12() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      a13() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      g13() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      f13() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      i13(enumDescriptor) {
        return this.neh_1;
      }
      e13() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      j13(descriptor) {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      c13() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      d13() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      x12() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      y12() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      b13() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
      h13() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().qd('An operation is not implemented: ' + reason);
      }
    }
    protoOf($).qz = decodeSerializableValue;
    initMetadataForClass($, 'EnumValueGetter', EnumValueGetter, VOID, [Decoder()]);
    EnumValueGetterClass = $;
  }
  return EnumValueGetterClass;
}
var MinEncoderClass;
function MinEncoder() {
  if (MinEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static reh() {
        var $this = this.d14();
        $this.oeh_1 = null;
        $this.peh_1 = get_DefaultSerializersModule();
        $this.qeh_1 = -1;
        return $this;
      }
      mz() {
        return this.peh_1;
      }
      f14(value) {
        if (this.qeh_1 === -1)
          this.oeh_1 = value;
        else {
          var tmp = this.oeh_1;
          var tmp0 = (!(tmp == null) ? isInterface(tmp, KtMutableMap()) : false) ? tmp : THROW_CCE();
          // Inline function 'kotlin.collections.set' call
          var key = this.qeh_1;
          tmp0.s3(key, value);
        }
      }
      e14(descriptor, index) {
        this.qeh_1 = index;
        return true;
      }
      l13(descriptor) {
        var tmp;
        if (this.qeh_1 === -1) {
          var tmp_0 = this;
          // Inline function 'kotlin.collections.mutableMapOf' call
          tmp_0.oeh_1 = LinkedHashMap().f6();
          tmp = this;
        } else {
          var l = MinEncoder().reh();
          // Inline function 'kotlin.collections.mutableMapOf' call
          var m = LinkedHashMap().f6();
          l.qeh_1 = 0;
          l.oeh_1 = m;
          var tmp_1 = this.oeh_1;
          var tmp0 = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap()) : false) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.collections.set' call
          var key = this.qeh_1;
          tmp0.s3(key, m);
          tmp = l;
        }
        return tmp;
      }
      h15(descriptor, index) {
        return true;
      }
      g14() {
        if (this.qeh_1 === -1)
          this.oeh_1 = null;
        else {
          var tmp = this.oeh_1;
          var tmp0 = (!(tmp == null) ? isInterface(tmp, KtMutableMap()) : false) ? tmp : THROW_CCE();
          // Inline function 'kotlin.collections.set' call
          var key = this.qeh_1;
          tmp0.s3(key, null);
        }
      }
    }
    initMetadataForClass($, 'MinEncoder', $.reh);
    MinEncoderClass = $;
  }
  return MinEncoderClass;
}
function MinDecoder$_get_indexIter_$ref_l1bzss() {
  return (p0) => p0.yeh();
}
var MinDecoderClass;
function MinDecoder() {
  if (MinDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(item) {
        super();
        this.teh_1 = item;
        this.ueh_1 = get_DefaultSerializersModule();
        this.veh_1 = -1;
        this.weh_1 = this.teh_1;
        var tmp = this;
        tmp.xeh_1 = lazy(() => {
          var tmp = this.teh_1;
          // Inline function 'kotlin.collections.iterator' call
          return ((!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE()).d2().m1();
        });
      }
      mz() {
        return this.ueh_1;
      }
      yeh() {
        var tmp0 = this.xeh_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('indexIter', 1, tmp, MinDecoder$_get_indexIter_$ref_l1bzss(), null);
        return tmp0.f2();
      }
      w12() {
        return ensureNotNull(this.weh_1);
      }
      x12() {
        return !(this.weh_1 == null);
      }
      b14(descriptor) {
        if (!this.yeh().n1())
          return -1;
        var l = this.yeh().o1();
        this.veh_1 = l.e2();
        this.weh_1 = l.f2();
        return l.e2();
      }
      l13(descriptor) {
        if (this.weh_1 == null) {
          // Inline function 'kotlin.collections.mapOf' call
          var tmp$ret$0 = emptyMap();
          return new (MinDecoder())(tmp$ret$0);
        }
        var tmp = ensureNotNull(this.weh_1);
        return new (MinDecoder())(isInterface(tmp, KtMap()) ? tmp : THROW_CCE());
      }
    }
    initMetadataForClass($, 'MinDecoder');
    MinDecoderClass = $;
  }
  return MinDecoderClass;
}
var getContextual$1Class;
function getContextual$1() {
  if (getContextual$1Class === VOID) {
    class $ extends AbstractDecoder() {
      constructor($this_getContextual, $box) {
        if ($box === VOID)
          $box = {};
        $box.zeh_1 = $this_getContextual;
        super($box);
      }
      mz() {
        return this.zeh_1;
      }
      b14(descriptor) {
        return 0;
      }
      qz(deserializer) {
        throw DesWrap().seh(deserializer);
      }
    }
    initMetadataForClass($);
    getContextual$1Class = $;
  }
  return getContextual$1Class;
}
//region block: exports
export {
  enumValues as enumValues198w9mpbetxy6,
  getContextual as getContextual3ijx86afthbix,
  get as getfcovrjca3cm8,
  serializationCast as serializationCast3kgcg1j7intug,
  set as set33aoyz3le40gz,
};
//endregion

//# sourceMappingURL=default.mjs.map
